<template>
    <p>this is an community page</p>
</template>

<script>
    export default {
        name: "index"
    }
</script>

<style scoped>

</style>
